import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// Components
import DesktopView from './DesktopView';
import MobileView from './MobileView';

// Utils
import isomorphicCookies from '../../utils/isomorphicCookies';

// Configs
import config from '../../config';

export default function LangSwitcher(props) {
  const { className } = props;

  const { isPhone, isTablet } = useSelector(state => state.responsive);
  const locale = useSelector(state => state.intl.locale);

  const isMobile = isPhone || isTablet;

  const onLocaleChange = newLocale => {
    if (newLocale !== locale) {
      isomorphicCookies().set('locale', newLocale);
      window.location.reload();
    }

    return null;
  };

  const View = isMobile ? MobileView : DesktopView;

  return (
    <View
      className={className}
      locales={config.langList}
      onLocaleChange={onLocaleChange}
      currentLocale={locale}
    />
  );
}

LangSwitcher.propTypes = {
  className: PropTypes.string,
};

LangSwitcher.defaultProps = {
  className: '',
};
